import { IS_AZHAR } from './actionTypes'

export const isAzharAction = (data) => {

    return {
        type: IS_AZHAR,
        payload: data
    }

}